// extracted by mini-css-extract-plugin
export default {"scoreButton":"oT8dFHpOWQLQHFopGYe3"};